
namespace GeniuzPOS.LogManage {

    @Serenity.Decorators.registerClass()
    export class LogUserPasswordChangeDateGrid extends Serenity.EntityGrid<LogUserPasswordChangeDateRow, any> {
        protected getColumnsKey() { return LogUserPasswordChangeDateColumns.columnsKey; }
        protected getDialogType() { return LogUserPasswordChangeDateDialog; }
        protected getIdProperty() { return LogUserPasswordChangeDateRow.idProperty; }
        protected getInsertPermission() { return LogUserPasswordChangeDateRow.insertPermission; }
        protected getLocalTextPrefix() { return LogUserPasswordChangeDateRow.localTextPrefix; }
        protected getService() { return LogUserPasswordChangeDateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected getButtons() {
			var button = super.getButtons();

            button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
            
            button.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: LogUserPasswordChangeDateService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));
                
                button.push(
                    {
                        title: Q.text("Close"), // *** Get button text from translation
                        cssClass: '.panel-titlebar-close',
                        icon: 'fa-close',
                        onClick: () => {
                            window.location.href = '/';
                            return false;
                        },
                    }
                );            
                
			// button.splice(Q.indexOf(button, x => x.cssClass == "add-button"), 1);
			return button;
		}
    }
}